import type { ActionFilters, ApiRequestFn, FetchInvoicesResult } from "../../types/api";
import type { PayInvoiceResponse, PaymentSource } from "../../types/payment";

const createActionsApi = (request: ApiRequestFn) => ({
  fetchInvoices: (filters?: ActionFilters) =>
    request<FetchInvoicesResult>("/me/actions/fetch-invoices", {
      method: "POST",
      body: JSON.stringify(filters || {}),
    }),

  payInvoice: (invoiceIds: number[], source?: PaymentSource) =>
    request<PayInvoiceResponse>("/me/actions/pay-invoice", {
      method: "POST",
      body: JSON.stringify({ invoiceIds, source }),
    }),

  startScraping: () =>
    request<{ jobId: string }>("/me/actions/start-scraping", {
      method: "POST",
    }),

  submit2fa: (code: string) =>
    request<{ success: boolean }>("/me/actions/submit-2fa", {
      method: "POST",
      body: JSON.stringify({ code }),
    }),
});

export { createActionsApi };
